export default __webpack_public_path__ + "static/media/Pavilion-I-II-Dark-Gray-Pewter-Charcoal.839612e0.jpg";